import { render, staticRenderFns } from "./DashboardAlbaranesRankingCenter.vue?vue&type=template&id=3e8ac246&scoped=true&lang=pug"
import script from "./DashboardAlbaranesRankingCenter.vue?vue&type=script&lang=js"
export * from "./DashboardAlbaranesRankingCenter.vue?vue&type=script&lang=js"
import style0 from "./DashboardAlbaranesRankingCenter.vue?vue&type=style&index=0&id=3e8ac246&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8ac246",
  null
  
)

export default component.exports